import React from 'react';
import { ChevronRight, type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SettingsLinkRowProps {
  icon: LucideIcon;
  label: string;
  description?: string;
  tone?: 'default' | 'warning';
  onSelect: () => void;
}

/**
 * A row that navigates. Replaces a button floating in a card: the whole row is
 * the hit target, and the chevron says where it goes.
 */
const SettingsLinkRow: React.FC<SettingsLinkRowProps> = ({
  icon: Icon,
  label,
  description,
  tone = 'default',
  onSelect,
}) => (
  <button
    type="button"
    onClick={onSelect}
    className={cn(
      'flex w-full items-center gap-3 px-4 py-3 text-left transition-colors duration-100',
      'hover:bg-accent/50 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring',
      'motion-reduce:transition-none',
    )}
  >
    <Icon
      className={cn('size-4 shrink-0', tone === 'warning' ? 'text-warning' : 'text-muted-foreground')}
      strokeWidth={1.9}
    />
    <span className="min-w-0 flex-1">
      <span className="revy-cjk block text-sm font-medium leading-[1.5]">{label}</span>
      {description && (
        <span className="revy-cjk mt-0.5 block text-xs leading-[1.7] tracking-[0.02em] text-muted-foreground">
          {description}
        </span>
      )}
    </span>
    <ChevronRight className="size-4 shrink-0 text-muted-foreground" strokeWidth={1.9} />
  </button>
);

export default SettingsLinkRow;
